/* eslint-disable @typescript-eslint/no-use-before-define */
import { Button, Divider, Typography } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { get } from 'lodash';
import { getLocalstorageToken } from '../../../../../../context/AuthHelper';
import GetRecords from '../../../../../../lib/api/GetRecords';
import { APIS } from '../../../../../../lib/constants/apis';
import { addIndexesToPath, getOptionsFromRes, removeDataKeys, removeNullDeep } from '../../../../../../utils/helper';
import AddIcon from '@mui/icons-material/Add';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { cloneDeep } from 'lodash';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import OrgaSchema from '../../../../../../lib/paths/organisation_FULL_Paths.json';
import { set } from 'lodash';
import MUIAlert from '../../../../../../components/ui-component/mui-alert/MUIAlert';
import MUIAccordionComponent from '../../../../../../components/ui-component/mui-accordion/MUIAccordionComponent';
import ComponentFieldBox from '../../../antrag-component/ComponentFieldBox';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { concat } from 'lodash';
const P = Schema.attributes;
const ORGA_P = OrgaSchema.attributes;

const Partner: FC<{}> = () => {
	const { application, setApplicationProperty, saveApplication, readOnly } = useApplication();
	const [partners, setPartners] = useState<any[]>([]);

	const updatePartner = (key: string, value: any, partnerIndex: number) => {
		let appCopy = cloneDeep(application);
		set(appCopy, key, value);
		if (
			!get(
				application,
				`${addIndexesToPath(P.Partner.schema.attributes.Unternehmen.path, [`${partnerIndex}`], ['Partner'])}.id`,
				'',
			)
		) {
			let orgaData = {
				attributes: {
					AN_Organisatoin: get(getLocalstorageToken(), 'organisationId'),
					Geschaeftsbezogene_Daten_Rolle: 'Projektpartner',
				},
			};
			const paths = {
				[ORGA_P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: get(
					appCopy,
					addIndexesToPath(P.Partner.schema.attributes.Name_Der_Organisation.path, [`${partnerIndex}`], ['Partner']),
				),
				[ORGA_P.Adressdaten_Strasse_Und_Hausnummer.path]: get(
					appCopy,
					addIndexesToPath(
						P.Partner.schema.attributes.Partner_Strasse_Und_Hausnummer.path,
						[`${partnerIndex}`],
						['Partner'],
					),
				),
				[ORGA_P.Adressdaten_PLZ.path]: get(
					appCopy,
					addIndexesToPath(P.Partner.schema.attributes.Partner_PLZ.path, [`${partnerIndex}`], ['Partner']),
				),
				[ORGA_P.Adressdaten_Ort.path]: get(
					appCopy,
					addIndexesToPath(P.Partner.schema.attributes.Partner_Ort.path, [`${partnerIndex}`], ['Partner']),
				),
				[ORGA_P.Kontaktdaten_Telefon.path]: get(
					appCopy,
					addIndexesToPath(P.Partner.schema.attributes.Partner_Telefonnummer.path, [`${partnerIndex}`], ['Partner']),
				),
				[ORGA_P.Kontaktdaten_E_Mail.path]: get(
					appCopy,
					addIndexesToPath(P.Partner.schema.attributes.Partner_E_Mail_Adresse.path, [`${partnerIndex}`], ['Partner']),
				),
			};
			for (const [orgaKey, orgaValue] of Object.entries(paths)) {
				set(orgaData, orgaKey, orgaValue);
			}
			set(appCopy, addIndexesToPath(P.Partner.schema.attributes.Unternehmen.path, [`${partnerIndex}`], ['Partner']), orgaData);
		}
		setApplicationProperty('attributes', get(appCopy, 'attributes'));
	};
	const handleSelectPartner = (key: string, value: any, partnerIndex: number) => {
		let appCopy = cloneDeep(application);
		const selectedPartner = partners.find((ele) => ele.id === parseInt(value));
		let partnerData = {};
		const paths = {
			[addIndexesToPath(P.Partner.schema.attributes.Name_Der_Organisation.path, [`${partnerIndex}`], ['Partner'])]:
				ORGA_P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path,
			[addIndexesToPath(P.Partner.schema.attributes.Partner_Strasse_Und_Hausnummer.path, [`${partnerIndex}`], ['Partner'])]:
				ORGA_P.Adressdaten_Strasse_Und_Hausnummer.path,
			[addIndexesToPath(P.Partner.schema.attributes.Partner_PLZ.path, [`${partnerIndex}`], ['Partner'])]:
				ORGA_P.Adressdaten_PLZ.path,
			[addIndexesToPath(P.Partner.schema.attributes.Partner_Ort.path, [`${partnerIndex}`], ['Partner'])]:
				ORGA_P.Adressdaten_Ort.path,
			[addIndexesToPath(P.Partner.schema.attributes.Partner_Telefonnummer.path, [`${partnerIndex}`], ['Partner'])]:
				ORGA_P.Kontaktdaten_Telefon.path,
			[addIndexesToPath(P.Partner.schema.attributes.Partner_E_Mail_Adresse.path, [`${partnerIndex}`], ['Partner'])]:
				ORGA_P.Kontaktdaten_E_Mail.path,
		};
		for (const [pathComponent, pathOrga] of Object.entries(paths)) {
			set(appCopy, pathComponent, get(selectedPartner, pathOrga));
		}
		set(appCopy, P.Partner.path + partnerIndex, partnerData);
		set(appCopy, key, value);
		setApplicationProperty('attributes', get(appCopy, 'attributes'));
	};

	const handleAddPartner = () => {
		try {
			let appCopy = cloneDeep(application);
			const data = {
				Partner_Strasse_Und_Hausnummer: '',
			};
			set(appCopy, `${P.Partner.path}.${get(application, P.Partner.path, []).length}`, data);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Adding Partner ', err);
		}
	};

	const handleAddAnsprechPartner = (partnerIndex: number) => {
		try {
			let appCopy = cloneDeep(application);
			const data = {
				Position: '',
			};
			// `${P.Partner.path}.${partnerIndex}.Partner_Ansprechpartnerin.${get(application, `${P.Partner.path}.${partnerIndex}.Partner_Ansprechpartnerin`, []).length}`;
			set(
				appCopy,
				addIndexesToPath(
					P.Partner.schema.attributes.Partner_Ansprechpartnerin.path,
					[
						`${partnerIndex}`,
						`${get(application, `${P.Partner.path}.${partnerIndex}.Partner_Ansprechpartnerin`, []).length}`,
					],
					['Partner', 'Partner_Ansprechpartnerin'],
				),
				data,
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Adding Partner ', err);
		}
	};

	const handleDeletePartner = (index: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allPartner = get(appCopy, P.Partner.path, []);
			set(
				appCopy,
				P.Partner.path,
				allPartner.filter((_: any, i: number) => i !== index),
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Partner ', err);
		}
	};

	const handleDeleteAP = (partnerIndex: number, apIndex: number) => {
		try {
			let appCopy = cloneDeep(application);
			const allAnsprechpartner = get(
				appCopy,
				addIndexesToPath(P.Partner.schema.attributes.Partner_Ansprechpartnerin.path, [`${partnerIndex}`], ['Partner']),
			);
			set(
				appCopy,
				addIndexesToPath(P.Partner.schema.attributes.Partner_Ansprechpartnerin.path, [`${partnerIndex}`], ['Partner']),
				allAnsprechpartner.filter((_: any, i: number) => i !== apIndex),
			);
			saveApplication(false, appCopy);
		} catch (err: any) {
			console.error('ERROR: Deleting Ansprechpartner ', err);
		}
	};

	useEffect(() => {
		const fetch = async () => {
			try {
				let filter = {
					AN_Organisatoin: get(getLocalstorageToken(), 'organisationId'),
					Geschaeftsbezogene_Daten_Rolle: 'Projektpartner',
				};
				let res = await GetRecords(APIS.Organisation, [], filter);
				setPartners(removeNullDeep(removeDataKeys(get(res, 'data', []))));
			} catch (err: any) {}
		};
		fetch();
	}, []);

	return (
		<>
			<Typography variant="h3">Partner</Typography>
			<MUIAlert message='Hier können Sie entweder einen vorhandenen Partner aus der Datenbank auswählen oder einen neuen hinzufügen, indem Sie den Name der Organisation eintragen und auf "Weiter" klicken' />
			{(get(application, P.Partner.path, [{}]) as Array<any>).map((_value, index) => {
				return (
					<MUIAccordionComponent
						key={index}
						summaryTitle={`Projektpartner 
							${get(
								application,
								addIndexesToPath(P.Partner.schema.attributes.Name_Der_Organisation.path, [`${index}`], ['Partner']),
								`${index + 1}`,
							)}`}
						onDelete={() => handleDeletePartner(index)}
						showDeleteButton={!isPartnerSelectFieldDisabled(application, index, readOnly)}
					>
						{isPartnerSelectFieldDisabled(application, index, readOnly) && (
							<MUIAlert message="In Ihrem Antrag sind einige Kosten mit diesem Partner verknüpft. Um den Partner aus dem Antrag zu entfernen, müssen Sie zunächst die entsprechenden Kosten löschen." />
						)}
						<Grid2 container spacing={6}>
							<Grid2 sm={6}>
								<CreateForm
									formStruc={mapPartner(formStrucPartnerRelation(partners, application, index, readOnly), index)}
									formValues={application}
									updateFormValuesFunc={(key, value) => handleSelectPartner(key, value, index)}
									readOnly={readOnly}
								/>
							</Grid2>
						</Grid2>
						<Grid2 container spacing={6}>
							<Grid2 sm={6}>
								<CreateForm
									formStruc={mapPartner(formStrucPartnerDetails, index)}
									formValues={application}
									updateFormValuesFunc={(key, value) => updatePartner(key, value, index)}
									readOnly={readOnly}
								/>
							</Grid2>
							<Grid2 sm={6}>
								<CreateForm
									formStruc={mapPartner(formStrucPartnerKontakt, index)}
									formValues={application}
									updateFormValuesFunc={(key, value) => updatePartner(key, value, index)}
									readOnly={readOnly}
								/>
							</Grid2>
						</Grid2>
						<Grid2 container spacing={6}>
							{get(_value, 'Partner_Ansprechpartnerin', []).map((_apvalue: any, j: number) => {
								return (
									<Grid2 sm={6} key={j}>
										<ComponentFieldBox
											index={j}
											title="Ansprechpartner"
											onDelete={() => handleDeleteAP(index, j)}
											showDeleteButton={!readOnly}
										>
											<CreateForm
												formStruc={mapPartnerAnsprechpartner(formStrucPartnerAP, index, j)}
												formValues={application}
												updateFormValuesFunc={setApplicationProperty}
												readOnly={readOnly}
											/>
										</ComponentFieldBox>
									</Grid2>
								);
							})}
						</Grid2>
						<Button
							sx={{ mt: '2rem' }}
							endIcon={<AddIcon />}
							onClick={() => handleAddAnsprechPartner(index)}
							disabled={readOnly}
						>
							Ansprechpartner hinzufügen
						</Button>
					</MUIAccordionComponent>
				);
			})}
			<Divider sx={{ mt: '2rem' }} />
			<Button sx={{ mt: '1rem' }} endIcon={<AddIcon />} onClick={handleAddPartner} disabled={readOnly}>
				Partner hinzufügen
			</Button>
		</>
	);
};

export default Partner;

const isPartnerSelectFieldDisabled = (application: any, index: number, readOnly: boolean) => {
	if (readOnly) return true;
	const partnerSelectedValue = get(
		application,
		addIndexesToPath(P.Partner.schema.attributes.Unternehmen.path, [`${index}`], ['Partner']),
	);

	let partnerID: number;
	if (typeof partnerSelectedValue === 'object') partnerID = partnerSelectedValue.id;
	else partnerID = partnerSelectedValue;

	const allAusgaben = get(application, P.Ausgaben.path, []);
	const allEinnahmen = get(application, P.Einnahmen.path, []);

	const checkIfPartnerhasAusgabe = allAusgaben.find((ele: any) => get(ele, 'Organisation.id') === partnerID);
	const checkIfPartnerhasEinnahme = allEinnahmen.find((ele: any) => get(ele, 'Organisation.id') === partnerID);

	if (checkIfPartnerhasAusgabe || checkIfPartnerhasEinnahme) return true;
	else return false;
};

const formStrucPartnerRelation = (partners: any, application: any, index: number, readOnly: boolean): FormStrucItem[] => {
	return [
		{
			fields: [
				{
					label: 'Liste der Partner',
					...P.Partner.schema.attributes.Unternehmen,
					type: 'singleSelect',
					options: getOptionsFromRes(partners, 'Geschaeftsbezogene_Daten_Name_Der_Organisation'),
					disabled: isPartnerSelectFieldDisabled(application, index, readOnly),
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
};
const formStrucPartnerDetails: FormStrucItem[] = [
	{
		fields: [P.Partner.schema.attributes.Name_Der_Organisation, P.Partner.schema.attributes.Partner_Strasse_Und_Hausnummer],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
	{
		fields: [P.Partner.schema.attributes.Partner_PLZ, P.Partner.schema.attributes.Partner_Ort],
	},
];

const formStrucPartnerKontakt: FormStrucItem[] = [
	{
		fields: [P.Partner.schema.attributes.Partner_Telefonnummer, P.Partner.schema.attributes.Partner_E_Mail_Adresse],
		userProps: { direction: 'column', columnToDivide: 1 },
	},
];

const formStrucPartnerAP: FormStrucItem[] = [
	{
		fields: [P.Partner.schema.attributes.Partner_Ansprechpartnerin.schema.attributes.Position],
		userProps: { columnToDivide: 1 },
	},
	{
		fields: [
			P.Partner.schema.attributes.Partner_Ansprechpartnerin.schema.attributes.Vorname,
			P.Partner.schema.attributes.Partner_Ansprechpartnerin.schema.attributes.Nachname,
		],
		userProps: { columnToDivide: 1 },
	},
	{
		fields: [
			P.Partner.schema.attributes.Partner_Ansprechpartnerin.schema.attributes.Telefonnummer,
			P.Partner.schema.attributes.Partner_Ansprechpartnerin.schema.attributes.E_45_Mail_45_Adresse,
		],
		userProps: { columnToDivide: 1 },
	},
];

const mapPartner = (formStruc: any[], index: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>).map((value) => {
				let pathWithoutIndex = get(value, 'path', '') as string;
				return {
					...value,
					path:
						pathWithoutIndex.slice(0, P.Partner.path.length) + `.${index}` + pathWithoutIndex.slice(P.Partner.path.length),
				};
			}),
		};
	});
	return result;
};

const mapPartnerAnsprechpartner = (formStruc: any[], index: number, apIndex: number) => {
	let result = formStruc.map((row) => {
		return {
			...row,
			fields: (get(row, 'fields', []) as Array<any>)
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Partner.schema.attributes.Partner_Ansprechpartnerin.path.length) +
							`.${apIndex}` +
							pathWithoutIndex.slice(P.Partner.schema.attributes.Partner_Ansprechpartnerin.path.length),
					};
				})
				.map((value) => {
					let pathWithoutIndex = get(value, 'path', '') as string;
					return {
						...value,
						path:
							pathWithoutIndex.slice(0, P.Partner.path.length) +
							`.${index}` +
							pathWithoutIndex.slice(P.Partner.path.length),
					};
				}),
		};
	});
	return result;
};

export const GetPartnerFormStruc = (application: any, readOnly: boolean): FormStrucItem[] => {
	const partner = get(application, P.Partner.path, []);

	let completeStruc: FormStrucItem[] = [];
	partner.forEach((eachPartner: any, index: number) => {
		let partnerStruc: any[] = [];
		const formStrucPartnerAPLength = get(eachPartner, 'Partner_Ansprechpartnerin', []).length;

		const PartnerRelationformStruc = mapPartner(formStrucPartnerRelation([], application, index, readOnly), index);
		const PartnerDetailsformStruc = mapPartner(formStrucPartnerDetails, index);
		const PartnerKontaktformStruc = mapPartner(formStrucPartnerKontakt, index);

		partnerStruc = concat(PartnerRelationformStruc, PartnerDetailsformStruc, PartnerKontaktformStruc);

		for (let i = 0; i < formStrucPartnerAPLength; i++) {
			partnerStruc = concat(partnerStruc, mapPartnerAnsprechpartner(formStrucPartnerAP, index, i));
		}

		completeStruc = concat(completeStruc, partnerStruc);
	});

	return completeStruc;
};
